export const RESET_OBSERVER = "RESET_OBSERVER";
export const OBSERVER_ERROR = "OBSERVER_ERROR";

export const CLOSE_OBSERVER = "CLOSE_OBSERVER";
export const CLOSED_OBSERVER = "CLOSED_OBSERVER";
